module.exports = __webpack_public_path__ + "img/vector.a38a6160.png";